import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { mapAPI } from "services/mapSlice";

import type { BuildingSchema } from "@repo/ping-react-js";

type InitialStateType = {
  meta?: Record<string, any>;
  hasDisplacement: boolean;
  isPingCertified: boolean;
  fieldOverrides: Record<string, any>;
  // undefined until the overview for overviewSovid loads.
  buildingSchema?: BuildingSchema;
  overviewSovid?: string;
  // The grid's visible column keys, which the buildings are fetched with.
  gridFields: string[] | null;
};

const initialState: InitialStateType = {
  meta: {},
  hasDisplacement: false,
  isPingCertified: false,
  fieldOverrides: {},
  gridFields: null,
};

const sovSlice = createSlice({
  name: "sov",
  initialState,
  reducers: {
    setHasDisplacement(state, action: PayloadAction<boolean>) {
      state.hasDisplacement = action.payload;
    },
    setIsPingCertified(state, action: PayloadAction<boolean>) {
      state.isPingCertified = action.payload;
    },
    setGridFields(state, action: PayloadAction<string[]>) {
      state.gridFields = action.payload;
    },
  },
  extraReducers(builder) {
    builder.addMatcher(
      mapAPI.endpoints.getPolicyOverview.matchFulfilled,
      (state, action) => {
        state.meta = {
          filename: action.payload?.filename,
          insuredName: action.payload?.insured_name,
        };
        state.hasDisplacement = action.payload?.displacement;
        state.isPingCertified = action.payload?.is_ping_certified;
        state.fieldOverrides = action.payload?.field_overrides;
        const buildingSchema: BuildingSchema = action.payload.building_schema;
        if (buildingSchema.layout_key !== state.buildingSchema?.layout_key) {
          state.gridFields = null;
        }
        state.buildingSchema = buildingSchema;
        state.overviewSovid = action.meta.arg.originalArgs.sovid;
      },
    );
  },
});

const { actions, reducer } = sovSlice;

const { setHasDisplacement, setIsPingCertified } = actions;

export const { setGridFields } = actions;

export default reducer;
